module.exports = __webpack_public_path__ + "prod/1.42.2/img/con1_bottom1.48921306.png";